import React from "react";

const Img = ({
  className,
  src = "defaultNoData.png",
  alt = "testImg",
  fetchPriority,
  ...restProps
}) => {
  if (
    src === "/assets/images/diya_lamp_small.webp" &&
    restProps.id === "lcp-diya-img"
  ) {
    return (
      <img
        className={className}
        src={src}
        alt={alt}
        loading="eager"
        fetchPriority="high"
        decoding="async"
        width={restProps.width || 336}
        height={restProps.height || 430}
        {...restProps}
      />
    );
  }
  const loadingProp = fetchPriority === "high" ? "eager" : "lazy";
  return (
    <img
      className={className}
      src={src}
      alt={alt}
      loading={loadingProp}
      fetchPriority={fetchPriority}
      decoding="async"
      {...restProps}
    />
  );
};

export { Img };
